import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { HotKeys } from 'react-hotkeys';
import cn from 'classnames';
import './style.scss';

const keyMap = {
  on: 'left',
  off: 'right',
  toggle: 'enter',
};

export default class Toggler extends Component {
  static propTypes = {
    className: PropTypes.string,
    input: PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
      onChange: PropTypes.func,
    }),
    isDisabled: PropTypes.bool,
    label: PropTypes.string,
    offValue: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    onToggle: PropTypes.func,
    onValue: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  };

  static defaultProps = {
    className: '',
    label: '',
    isDisabled: false,
    value: true,
    onValue: true,
    offValue: false,
  };

  state = {
    on: this.props.input // case Toggler is part of a redux-form
      ? this.props.input.value
      : this.props.value === this.props.onValue,
  };

  componentWillReceiveProps({ value, input }) {
    this.setState({
      on: input ? input.value : value === this.props.onValue,
    });
  }

  handleToggle = e => {
    const { onValue, offValue, onToggle, input, isDisabled } = this.props;

    e.stopPropagation();
    e.preventDefault();

    if (!isDisabled) {
      this.setState(
        ({ on }) => ({ on: !on }),
        () => {
          const value = this.state.on ? onValue : offValue;

          if (onToggle) {
            onToggle(value);
          }
        },
      );
      // FIXME: define redux-form wrapper separately under `Form` folder
      // case Toggler is part of a redux-form
      if (input) {
        input.onChange(!input.value);
      }
    }
  };

  keyHandlers = {
    toggle: this.handleToggle,
    on: () => {
      const { onToggle, input } = this.props;

      this.setState(
        {
          on: true,
        },
        () => {
          if (onToggle) {
            onToggle(true);
          }
          // FIXME: define redux-form wrapper separately under `Form` folder
          // case Toggler is part of a redux-form
          if (input) {
            input.onChange(true);
          }
        },
      );
    },
    off: () => {
      const { onToggle, input } = this.props;
      this.setState({ on: false }, () => {
        if (onToggle) {
          onToggle(false);
        }
        // FIXME: define redux-form wrapper separately under `Form` folder
        // case Toggler is part of a redux-form
        if (input) {
          input.onChange(false);
        }
      });
    },
  };

  render() {
    const { className, label, isDisabled } = this.props;
    const { on } = this.state;

    /* eslint-disable jsx-a11y/click-events-have-key-events */
    /* eslint-disable jsx-a11y/no-static-element-interactions */
    return (
      <HotKeys
        className="toggler-wrapper"
        handlers={!isDisabled ? this.keyHandlers : {}}
        keyMap={!isDisabled ? keyMap : {}}
      >
        <button
          className={className}
          data-test="toggler-button"
          disabled={isDisabled}
          styleName={cn('toggler', { 'is-disabled': isDisabled })}
          type="button"
          onClick={this.handleToggle}
        >
          {label && <span styleName="label">{label}</span>}
          <div
            data-test="toggler"
            styleName={cn('container', {
              'is-disabled': isDisabled,
              'is-active': on,
            })}
            onClick={this.handleToggle}
          >
            <span styleName="circle" />
          </div>
        </button>
      </HotKeys>
    );
  }
}
